import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { DataService, Request } from '../services/data-service';
import { RouterEvent } from 'aurelia-router';
import {EventAggregator} from 'aurelia-event-aggregator';

@inject(EventAggregator, DataService, Router)
export class AppNavbar {
	/** Component methods **/
	constructor(ea, ds, router){
		this.ds		= ds;
		this.ea		= ea;
		this.router = router;
		this.selectedTab = "models";
		this.display_navbar = false;
		
	}

	attached(){
		// Add subscriptions
		this.selectTabSubs = this.ea.subscribe(RouterEvent.Complete, (event) => this.onSelectTab(event));
		//this.selectTabSubs = this.ea.subscribe(RouterEvent.Processing, (event) => this.onProcessing(event));
		window.setTimeout( () => {this.init()}, 600);
	}

	init(){
		let routeName = this.router.currentInstruction.config.name;
		this.routeName = "-"+routeName;
		//this.selectTab(routeName)
		// Get user id (uid)
		let uid = this.ds.user.uid;
		// Show app-navbar
		if(uid){
			this.uid = uid;
			//this.display_navbar = true;
			this.shouldDisplayNavbar(this.routeName);
		}
	}

	shouldDisplayNavbar(routeName){
		//let pattern = /-models$|-templates$|-datasets$|-profile$|-models.data$/i
		let pattern = /-models$|-templates$|-datasets$|-profile$/i
		window.setTimeout( () => {
			if(!pattern.test(routeName)){
				this.display_navbar = false;
			}
			else{
				window.setTimeout( () => {
					
					let uid = this.ds.user.uid;
					this.uid = uid
					this.display_navbar = true;
				}, 300);
				
			}
		}, 100);
	}
 
	/** Custom methods **/
	selectTab(tab){ this.selectedTab = tab;}

	onProcessing(event){
		console.log("event => ", event);
	}

	/** Events **/
	onSelectTab(event){
		let routeName = "-"+event.instruction.config.name;
		//let pattern = /-models$|-templates$|-datasets$|-profile$|-models.data$/i
		let pattern = /-models$|-templates$|-datasets$|-profile$/i
		//
		window.setTimeout( () => {
			if(!pattern.test(routeName)){
				this.display_navbar = false;
			}
			else{
				window.setTimeout( () => {
					let uid = (this.ds.user) ? this.ds.user.uid : null;
					this.uid = uid
					this.display_navbar = true;
				}, 300);
				
			}
		}, 100);
	}
}
